<template>
  <div class='interview_wrapper'>
    <step-status :step="$route.meta.step" class="mt55"></step-status>


    <h1 v-if='$route.query.status !== "canceled" && $route.query.status !== "rescheduled"'>
      Hi {{full_name}}, <br /> Thank you for attending the Orientation session, and welcome to the HAWO Group Class (GC) training program!<br /> Please see your Teaching Practice Session schedule below:<br /> Take note that you must finish modules 1-3 before your scheduled Teaching Practice Session.
    </h1>

    <h1 v-if='$route.query.status=="rescheduled"'>Hi {{full_name}}, your teaching practice guide appointment has been rescheduled.</h1>

    <h1 v-if='$route.query.status=="canceled"'>Dear {{full_name}}, you've cancelled your scheduled teaching practice guide time. You may request a new appointment. </h1>

    <div class="schedule">
      <h4>Your scheduled Teaching Practice Session time</h4>
      <div class='date_select' v-show='false'>

      </div>

      <div class='schedule_de clearfix'>
        <div class="left">
          <ul>
            <li class='clearfix'>
              <span>Time Zone：</span>
              <p>{{appointment.timezone}}</p>
            </li>
            <li class='clearfix'>
              <span>Date & Time：</span>
              <p>{{date_time}}</p>
            </li>
            <!-- <li class='clearfix'>
              <span>Trainer：</span>
              <h1>
                <p>{{staff.name}}</p> -->
                <!-- <p v-show='staff.zoom_id'>Zoom account : {{staff.zoom_id}}</p> -->
                <!-- <p v-show='staff.email'>Email : {{staff.email}}</p>
                <p v-show='staff.skype'>skype : {{staff.skype}}</p>
              </h1>
            </li> -->
            <li class='clearfix'>
              <span>Where：</span>
              <p>Your teaching practice session will be conducted on AC.<br /> Please contact your recruiter for your AC login credentials.</p>
              <!-- <p>Your teaching practice guide will be conducted on Zoom.</p> -->
            </li>
          </ul>
        </div>
        <div class="right">
          <el-tooltip class="item" effect="dark" content="Kindly contact your recruiter since you've already rescheduled/cancelled once." placement="right" :disabled="canReschedule">
            <a class='style reschedule' :class="{dis: !canReschedule}" @click='showPop'>{{$route.query.status=="canceled" ? 'Schedule' : 'Reschedule' }}</a>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="Kindly contact your recruiter since you've already rescheduled/cancelled once." placement="right" v-if="date_time" :disabled="canReschedule">
            <a class='style cancel' :class="{dis: !canReschedule}" @click='cancel_apo'>Cancel Appointment</a>
          </el-tooltip>

          <a class='need_help' v-if="need_help" :href='`mailto:${need_help}`'>Have questions? Email here</a>
        </div>
      </div>

      <p class="tip">
        Failure to attend your scheduled teaching practice session may disqualify you for the position.<br /> Please contact your recruiter if you need any assistance, or if you have any questions.
      </p>
      <!-- <ul class='explain' >
			<li>Before attending the live teaching practice guide, make sure to complete the self-paced videos.</li>
		</ul> -->
    </div>
    <!-- <div class="preparation">
      <h4>Complete the following self-paced modules
        <span class='incomplete' v-show='!complete_ntt'>
          <i></i>
          Incomplete
        </span>
        <span class='complete' v-show='complete_ntt'>
          <i></i>
          Complete
        </span>
      </h4>

      <div class="preparation_de">
        <p>
          <a target='_blank' :href='ntt_url'>Click here </a>to access your self-paced module.</p>
        <div>
          <ul>
            <li>These videos will cover how to utilize various teaching tools.</li>
            <li>You must complete these video modules before moving on to the live teaching practice guide Session.</li>
            <li>There will be a short quiz after each video. You’ll need to pass this quiz to complete the module .</li>
            <li>The videos should take no more than one hour to complete.</li>
          </ul>
        </div>
      </div>
      <div class='tms_module' v-show='false'>
        <div class="file_tree">
          <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        </div>
        <div class="video_list">
          <ul class='clearfix'>
            <li>
              <img src="~@img/video_t.jpg" alt="video">
              <div>
                <h4>Effective Warm Ups</h4>
                <p>Corretness: 4 out of 5
                  <span class='finish'>finish</span>
                </p>
              </div>
            </li>
            <li>
              <img src="~@img/video_t.jpg" alt="">
              <div>
                <h4>Effective Warm Ups</h4>
                <p>Corretness: 4 out of 5
                  <span class='unfinish'>unfinish</span>
                </p>
              </div>
            </li>
            <li class='locked'>
              <img src="~@img/video_t.jpg" alt="video">
              <div class="lock"></div>
              <div>
                <h4>Effective Warm Ups</h4>
                <p>Corretness: 4 out of 5
                  <span>finish</span>
                </p>
              </div>
              <div class="lock">
                <img src="~@img/locked.png" alt="lock">
                <div class='shadow'></div>
              </div>
            </li>
            <li class='locked'>
              <img src="~@img/video_t.jpg" alt="video">
              <div>
                <h4>Effective Warm Ups</h4>
                <p>Corretness: 4 out of 5
                  <span>finish</span>
                </p>
              </div>
              <div class="lock">
                <img src="~@img/locked.png" alt="lock">
                <div class='shadow'></div>
              </div>
            </li>
            <li class='locked'>
              <img src="~@img/video_t.jpg" alt="video">
              <div>
                <h4>Effective Warm Ups</h4>
                <p>Corretness: 4 out of 5
                  <span>finish</span>
                </p>
              </div>
              <div class="lock">
                <img src="~@img/locked.png" alt="lock">
                <div class='shadow'></div>
              </div>
            </li>
            <li class='locked'>
              <img src="~@img/video_t.jpg" alt="video">
              <div>
                <h4>Effective Warm Ups</h4>
                <p>Corretness: 4 out of 5
                  <span>finish</span>
                </p>
              </div>
              <div class="lock">
                <img src="~@img/locked.png" alt="lock">
                <div class='shadow'></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
    <div class="session">
      <h4>Live Training Session</h4>
      <div class="preparation_de">
        <p>Please take note of these further instructions for the session:</p>
        <div>
          <ul>
            <li>Please add trainer as a contact on Zoom 30 minutes before the training and send them your updated speed test result link as a confirmation for <br>the training session.</li>
            <li>Please have your HEADSET set up for the session. You need a corded headset (USB plugged) with noise cancellation feature. </li>
            <li>Please have the right background set up. You should have a solid light colored background with adequate lighting and no distractions.</li>
            <li>You must be using a laptop or PC (Windows or Mac) – Do not use a mobile or tablet.</li>
            <!-- <li v-if='is1v1'>During your live training session, you will be required to access your teacher account. You may do so using the button below,</li> -->
          </ul>
          <!-- <mypage v-if='is1v1'></mypage> -->
        </div>
      </div>
    </div>

    <div class="session session-s">
      <h4>Training Modules</h4>
      <div class="preparation_de no_bg">
        <p>
          <a :href="urls.trainingModulesLink" target="_blank">{{urls.trainingModulesLink}}</a>
        </p>
      </div>
    </div>

    <div class="pop" v-show='reschedule_show'>
      <reschedule @getTutorInfo="getTutorInfo" :scheduled-time-zone="appointment.timezone_key" :scheduled-start-time="appointment.start_time" :scheduled-end-time="appointment.end_time" :time-zone='options' :book-type="bookType" :sureHandler="confirmOpen" :queryStatus="$route.query.status"></reschedule>
    </div>
    <div class="download">
      <ul class="clearfix">
        <li>
          <ac></ac>
        </li>
      </ul>
    </div>
    <cancel-confirm ref="cancelConfirm"></cancel-confirm>
    <!-- Google pixel -->
    <div style="display:inline;" v-if='$route.query.status=="assigned"'>
      <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=jUeFCKHuyngQu9OslgM&amp;guid=ON&amp;script=0" />
    </div>
    <div style="display:inline;" v-if='$route.query.status=="canceled"'>
      <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=5q8jCM_HsngQu9OslgM&amp;guid=ON&amp;script=0" />
    </div>
    <!-- status==rescheduled -->
    <div style="display:inline;" v-if='$route.query.status=="rescheduled"'>
      <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=iMvTCMvGsngQu9OslgM&amp;guid=ON&amp;script=0" />
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
import reschedule from '../other/tpg_demo_reschedule'
import CancelConfirm from '../other/CancelConfirm.vue'
import ac from '@common/ac'
import { urls } from '@js'

export default {
  data() {
    return {
      urls,
      bookType: 'tpg',
      data: [
        {
          label: '一级 1',
          children: [
            {
              label: '二级 1-1',
              children: [
                {
                  label: '三级 1-1-1'
                }
              ]
            }
          ]
        },
        {
          label: '一级 2',
          children: [
            {
              label: '二级 2-1',
              children: [
                {
                  label: '三级 2-1-1'
                }
              ]
            },
            {
              label: '二级 2-2',
              children: [
                {
                  label: '三级 2-2-1'
                }
              ]
            }
          ]
        },
        {
          label: '一级 3',
          children: [
            {
              label: '二级 3-1',
              children: [
                {
                  label: '三级 3-1-1'
                }
              ]
            },
            {
              label: '二级 3-2',
              children: [
                {
                  label: '三级 3-2-1'
                }
              ]
            }
          ]
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      options: '',
      value8: '',
      appointment: {
        timezone: ''
      },
      staff: {
        name: '',
        zoom_id: '',
        email: '',
        skype: ''
      },
      date_time: '',
      need_help: '',
      isMac: false,
      isWindows: false,
      words: {
        rescheduled: false
      },
      ntt_url: '',
      is1v1: false,
      canReschedule: false
    }
  },
  beforeRouteEnter(from, to, next) {
    next(vm => {
      //判断是否是1v1
      //...
      vm.$http.get('/Boarding/getTutor').then(d => {
        if (d.data.code == '75000') {
          let teacherType = d.data.res.info.sa_version
          switch (teacherType) {
            case '1':
              vm.is1v1 = true
              break
            case '2':
              vm.is1v1 = false
              break
          }
        }
      })
      vm.$http.get('/common/getConfig?key=time_zone').then(d => {
        if (d.data.code == '75000') {
          vm.options = d.data.res.time_zone
        }
      })
      vm.$http.get('/tpg/getAppointmentInfo').then(d => {
        if (d.data.code == '75000' && d.data.res.appointment) {
          vm.appointment = d.data.res.appointment

          vm.staff = d.data.res.staff

          //渲染时间
          let start_date = vm.appointment.start_time

          let end_date = vm.appointment.end_time

          let start_hours = start_date.split(' ')[1].slice(0, 5)

          let end_hours = end_date.split(' ')[1].slice(0, 5)

          let years = start_date.split(' ')[0]

          let times = ['AM', 'Noon', 'PM'] //曾经的时间显示格式为12:00:00 AM/April 17,2017，现在改为12:00:00-13:00 /April 17,2017

          let months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
          ]

          let full_date = new Date(years)

          if (start_hours == '12:00:00') {
            times = times[1]
          } else if (start_hours.split(':')[0] > 12) {
            times = times[2]
          } else if (start_hours.split(':')[0] < 12) {
            times = times[0]
          }

          vm.date_time =
            start_hours +
            '-' +
            end_hours +
            ' / ' +
            vm.appointment.working_date_formatted
          //修改'日'为后台返回数据，是因为，当时区跨度较大的时候，会导致，'日'出现错误。
        }
      })

      // vm.$http.get('/tpg/getSelfPacedUrl').then(d => {
      //   if (d.data.code == '75000') {
      //     vm.ntt_url = d.data.res.self_paced_url
      //   }
      // })
    })
  },
  methods: {
    handleNodeClick(data) {},
    getTutorInfo({ reschedule_status, interviewer_info }) {
      this.canReschedule = reschedule_status == 1
      this.need_help = interviewer_info.interviewer_email
    },
    showPop() {
      if (!this.canReschedule) return
      this.$store.commit('reschedule_pop_show')
    },
    async cancel_apo() {
      if (!this.canReschedule) return

      const { remark } = await this.confirmOpen({
        type: 'cancel'
      })

      let params = new URLSearchParams()
      let date = this.appointment.working_date + ' ' + this.switch_time
      params.append('timezone', this.appointment.timezone_key)
      params.append('working_date', date)
      params.append('working_time', this.appointment.work_hour_value)
      params.append('action', 'cancel')
      params.append('remark', remark)
      this.axios.post('/tpg/schedule', params).then(d => {
        if (d.data.code == '75000') {
          this.$message.success('Success!')
          window.location.reload()
          // this.$router.replace('/book_tpg?status=canceled')
        } else {
          this.$message.error(d.data.message)
        }
      })
    },
    confirmOpen(data) {
      return this.$refs.cancelConfirm.open(data)
    }
  },
  components: {
    reschedule,
    ac,
    CancelConfirm
    // mypage
  },
  mounted: function() {},
  computed: {
    reschedule_show() {
      return this.$store.state.pop_up
    },
    switch_time() {
      return this.$store.state.switch_time
    },
    from() {
      try {
        let params = window.location.href.split('?')[1]
        let arrs = params.split('&')
        for (let opt of arrs) {
          if (opt.split('=')[0] == 'status') {
            return opt.split('=')[1]
          }
        }
      } catch (e) {
        return ''
      }
    },
    complete_ntt() {
      return this.$store.state.ntt_self_complete
    },
    full_name() {
      return this.$store.state.full_name
    }
  }
}
</script>
<style lang='less' scoped>
.interview_wrapper {
  width: 1000px;
  margin: 0 auto;
  & > img {
    margin-top: 55px;
  }
  & > h1 {
    font-size: 16px;
    color: #1e1e1e;
    font-weight: bold;
    margin-top: 55px;
    line-height: 1.4;
  }
  .schedule {
    padding-top: 44px;
    .date_select {
      margin-top: 30px;
    }
    & > h4 {
      font-size: 24px;
      font-weight: bold;
      color: #febf00;
    }
    .schedule_de {
      margin-top: 29px;
      background: #f7f7f7;
      padding: 40px 30px;
      border-radius: 10px;
      .left {
        float: left;
        width: 706px;
        border-right: 1px solid #e0e0e0;
        font-size: 14px;
        border-radius: 10px;
        & > h4 {
          font-size: 14px;
          color: #525252;
          font-weight: bold;
        }
        & > ul {
          li {
            padding-top: 24px;
            line-height: 18px;
            & > * {
              float: left;
            }
            span {
              width: 100px;
              color: #999999;
              vertical-align: top;
            }
            h1 {
              height: 65px;
            }
            p {
              color: #1e1e1e;
            }
          }
        }
      }
      .right {
        float: left;
        width: 230px;
        a {
          cursor: pointer;
          display: block;
        }
        a:nth-child(1) {
          margin-top: 28px;
        }
        .style {
          width: 152px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 1px solid #fcc800;
          border-radius: 10px;
          color: #febf00;
          background: #fbfcfc;
          margin: 0 auto 20px;
        }
        .style {
          width: 152px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          text-align: center;
          border: 1px solid #fcc800;
          border-radius: 10px;
          color: #febf00;
          background: #fbfcfc;
        }
        .dis {
          cursor: not-allowed;
          color: #666;
          border-color: #ccc;
          background: #f3f3f3;
        }
        .need_help {
          font-size: 13px;
          text-decoration: underline;
          color: #1e1e1e;
          text-align: center;
          display: block;
        }
      }
    }
  }
  .preparation {
    padding-top: 44px;
    & > h4 {
      position: relative;
      font-size: 24px;
      color: #febf00;
      font-weight: bold;
      width: 750px;
      span {
        position: absolute;
        top: 5px;
        right: 120px;
        height: 16px;
        line-height: 16px;
        font-size: 14px;
        padding-left: 20px;
        text-align: left;
        i {
          position: absolute;
          left: 0;
          top: 0;
          height: 16px;
          width: 17px;
          background: url('~@img/complete_status.png') no-repeat 0 0;
        }
      }
      .complete {
        color: #29b36a;
        i {
          background-position: 0 0;
        }
      }
      .incomplete {
        color: #fd4c6e;
        i {
          background-position: -17px 0;
        }
      }
    }

    .tms_module {
      margin-top: 30px;
      border: 1px solid #e0e0e0;
      height: 486px;
      border-radius: 10px;
      & > div {
        float: left;
        height: 486px;
        box-sizing: border-box;
      }
      .file_tree {
        border-right: 1px solid #e0e0e0;
        width: 187px;
      }
      .video_list {
        width: 811px;
        background: #fafafa;
        & > ul {
          padding: 25px 0 0 34px;
          .locked {
            position: relative;
            .lock {
              position: absolute;
              left: 0;
              top: 0;
              width: 232px;
              height: 209px;
              padding: 0;
              line-height: 206px;
              text-align: center;
              img {
                position: relative;
                z-index: 999;
              }
              div {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: #fff;
                opacity: 0.6;
                filter: alpha(opacity=70);
                z-index: 99;
              }
            }
          }
          li {
            float: left;
            height: 206px;
            width: 234px;
            margin: 0 25px 25px 0;
            background: #fff;
            cursor: pointer;
            & > img {
              width: 234px;
              height: 134px;
            }
            & > div {
              height: 72px;
              border: 1px solid #e0e0e0;
              padding-left: 15px;
              border-top: none;
              h4 {
                padding-top: 20px;
                font-size: 14px;
                color: #1e1e1e;
              }
              p {
                padding-top: 14px;
                font-size: 14px;
                color: #999999;
                span {
                  float: right;
                  width: 53px;
                  height: 17px;
                  line-height: 17px;
                  font-size: 12px;
                  color: #fff;
                  border-radius: 50px;
                  margin-right: 9px;
                }
                span.finish {
                  background: #29b36a url('~@img/finish.png') no-repeat 6px
                    center;
                  text-indent: 1.5em;
                }
                span.unfinish {
                  background: #fd4c6e;
                  text-align: center;
                }
              }
            }
          }
        }
      }
    }
  }
  .preparation_de {
    margin-top: 29px;
    background: #f7f7f7;
    padding: 30px 30px;
    border-radius: 10px;
    font-size: 14px;
    color: #1e1e1e;

    &.no_bg {
      background: none;
    }

    & > p {
      padding-bottom: 14px;
      & > a {
        color: #009cff;
        text-decoration: underline;
      }
    }

    & > div {
      h4 {
        font-weight: bold;
      }
      ul {
        li {
          padding-bottom: 20px;
          margin-left: 20px;
          list-style: disc outside;
          line-height: 20px;
          a {
            color: #009cff;
            text-decoration: underline;
          }
        }
      }
    }
  }
  .session {
    padding-top: 40px;

    &.session-s {
      margin-bottom: 80px;

      .preparation_de {
        padding: 0;
      }
    }

    & > h4 {
      font-size: 24px;
      font-weight: bold;
      color: #febf00;
    }
    .session_cont {
      padding: 30px;
      background-color: #f7f7f7;
      border-radius: 10px;
      margin-top: 29px;
    }
    p {
      padding-bottom: 20px;
      font-size: 14px;
    }
  }
  .download {
    position: fixed;
    top: 166px;
    right: 80px;
    & > ul {
      width: 75px;
      li {
        float: left;
        margin-top: 6px;
        background-color: #fff;
        border-radius: 5px;
      }
    }
  }
  .downLoad.mypage_icon {
    margin-left: 20px;
  }
}
ul.explain > li {
  font-size: 14px;
  list-style: disc inside;
  padding-top: 30px;
}

.tip {
  line-height: 1.4;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// tpg.vue?b497898a